// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4869":"5d23fd39","7141":"5d23fd39"}[chunkId] + ".chunk.css";
};